<template>
    <div class="container mt-2">
        <div class="booking-expand clearfix">
            <form action="" class="col-12 col-md-12" style="padding: 0 !important;">
                <div class="table-noborder mb-0">

                    <div class="title-seat">
                        <div class="row ml-0 mr-0">
                            <div class="col-md-4 col-lg-4" style="position:relative;">1 - CHỌN CHỖ
                                <span class="btn btn-close-road hidden-lg hidden-md">
                                <img src="../../../assets/images/closed-white.svg" alt="">
                            </span>
                            </div>
                            <div class="col-md-4 col-lg-4">2 - CHỌN ĐIỂM ĐÓN/ĐIỂM TRẢ</div>
                            <div class="col-md-4 col-lg-4">3 - THÔNG TIN KHÁCH HÀNG
                                <span class="btn btn-close-road btn-close-road-phone">
                                    <img src="../../../assets/images/closed.svg" alt="">
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="detail-booking" style="height: 358px;">
                        <div class="row mr-0 ml-0 h-100">
                            <div class="col-md-4 col-lg-4 seat-template-col">
                                <seat-map v-model="form.seats"
                                          :seats_available="seats_available"
                                          :ticket_price_common="ticket_price_common"
                                          @totalPrice="total_price = $event"
                                          :v="$v.form.seats">

                                </seat-map>
                            </div>
                            <div class="col-md-4 col-lg-4 seat-template-col">
                                <place-detail :v="$v.form.places">

                                </place-detail>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <customer-info v-model="form.customer"
                                               :v="$v.form.customer">

                                </customer-info>
                            </div>
                        </div>
                    </div>

                    <div class="detail-review" style="min-height: 70px">
                        <div class="row ml-0 mr-0">
                            <div class="col-md-4 col-lg-4 col-sm-4 col-12 detail-total">
                                <seat-preview :seats="form.seats" :price="total_price"></seat-preview>
                            </div>
                            <div class="col-md-4 col-lg-4 detail-review-route">
                                <place-preview :places="$v.form.places"></place-preview>
                            </div>
                            <div class="column-butom col-md-4 col-lg-4 col-xs-12">
                                <div class="form-group mb-0">
                                    <div class="col-md-12 col-sm-12 cont-container text-center">
                                        <button @click.stop="submit" type="button" class="cont-btn btn btn-vxr-lg btn-vxr-lg-action">
                                            Tiếp tục <i class="glyphicon glyphicon-chevron-right f14"></i>
                                        </button>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { SeatMap, PlaceDetail, CustomerInfo, SeatPreview, PlacePreview } from "../shared/components";
    import {minLength, required, minValue} from "vuelidate/lib/validators";
    import {RepositoryFactory, MixinHelper, eventBus, EVENTS} from "../../shared/services";
    import addMinutes from 'date-fns/addMinutes';
    import {HCROUTES} from "../../shared/constants/Constant";

    const repo = RepositoryFactory.get('schedules');

    export default {
        name: "BookingDetail",
        mixins: [MixinHelper],
        props: {
            schedule: {
                type: Object,
                required: true
            },
            query_params: {
                type: Object,
                required: true
            },

        },
        components: {PlacePreview, SeatPreview, CustomerInfo, PlaceDetail, SeatMap},
        created() {
            this.schedule_id = this.getProp(this.schedule, 'id', null);
            repo.single(this.schedule_id, this.query_params)
                .then(res => {
                    this.ticket_price_common = this.getProp(res, 'data.data.common_ticket.price', 0);
                    this.seats_available = this.getProp(res, 'data.data.seats', []);
                })
                .catch(err => console.log(err));

            eventBus.$on(EVENTS.add_pickup_location, this.addPickupLocation);
            eventBus.$on(EVENTS.remove_pickup_location, this.removePickupLocation);
            eventBus.$on(EVENTS.add_getOff_location, this.addGetOffLocation);
            eventBus.$on(EVENTS.remove_getOff_location, this.removeGetOffLocation);
        },
        data() {
            return {
                schedule_id: null,
                seats_available: [],
                ticket_price_common: 0,
                total_price: 0,
                form: {
                    seats: [],
                    places: {
                        pickupLocations: [{distance_library_id: 0, address: '', people_quantity: 1}],
                        getOffLocations: [{address: ''}]
                    },
                    customer: {
                        name: '',
                        phone_number: '',
                        note: ''
                    }
                }
            }
        },
        validations: {
            form: {
                seats: {
                    required,
                    minLength: minLength(1),
                },
                places: {
                    pickupLocations: {
                        required,
                        minLength: minLength(1),
                        $each: {
                            distance_library_id: {},
                            address: {
                                required
                            },
                            people_quantity: {
                                minValue: minValue(1),
                                required
                            }
                        }
                    },
                    getOffLocations: {
                        required,
                        minLength: minLength(1),
                        $each: {
                            address: {
                                required
                            }
                        }
                    }
                },
                customer: {
                    name: {
                        required,
                        minLength: minLength(4)
                    },
                    phone_number: {
                        required
                    },
                    note: {}
                }
            }
        },
        methods: {
            submit() {
                this.$v.$touch();
                
                if (this.$v.form.seats.$pending || this.$v.form.seats.$error) {
                    this.$modalNotify.show({
                       content: 'Vui lòng chọn ít nhất 1 chỗ ngồi'
                    });
                    return;
                }

                if (this.$v.form.places.$pending || this.$v.form.places.$error) {
                    this.$modalNotify.show({
                        content: 'Vui lòng chọn điểm đi, điểm đón'
                    });
                    return;
                }

                if (this.$v.form.customer.$pending || this.$v.form.customer.$error) {
                    return;
                }

                if (!this.isPeopleQuantityPickupEqualsSeatQuantity(this.form)) {
                    this.$modalNotify.show({
                        content: 'Số lượng người đón phải bằng số lượng ghế đã đặt'
                    });
                    return;
                }

                if (!this.$store.getters.isAuthenticated) {
                    this.$modalAuth.show();
                    return;
                }

                const dataTransfer = {
                    totalPrice: this.total_price,
                    formData: this.buildDataCreateOrder({...this.form, schedule_id: this.schedule_id, query_params: this.query_params}),
                    seats_preview: this.form.seats,
                    schedule: this.schedule,
                    expire: addMinutes(new Date(), 15).valueOf()
                };
                this.removeData('order_id');
                this.storeData('data_order', dataTransfer);
                this.$router.push({name: HCROUTES.payment});
            },
            addPickupLocation() {
                this.form.places.pickupLocations.push({distance_library_id: 0, address: '', people_quantity: 1});
            },
            removePickupLocation(index) {
                this.form.places.pickupLocations.splice(index, 1);
            },
            addGetOffLocation() {
                this.form.places.getOffLocations.push({address: ''});
            },
            removeGetOffLocation(index) {
                this.form.places.getOffLocations.splice(index, 1);
            }
        },
        beforeDestroy() {
            eventBus.$off(EVENTS.add_pickup_location);
            eventBus.$off(EVENTS.remove_pickup_location);
            eventBus.$off(EVENTS.add_getOff_location);
            eventBus.$off(EVENTS.remove_getOff_location);
        }
    }
</script>

<style scoped>
    /*@import '~bootstrap/dist/css/bootstrap.min.css';*/
    .booking-expand {
        background: #f0f0f0;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 2px;
        padding-right: 2px;
        position: relative;
        border-radius: 5px;
    }

    .title-seat {
        float: left;
        width: 100%;
        font-weight: 700;
        height: 45px;
        line-height: 45px;
        border-radius: 5px 5px 0 0;
    }

    .detail-booking {
        border-bottom: 1px solid #eee;
        background: #fff;
    }

    .seat-template-col {
        border-right: 1px solid #eee !important;
        padding-right: 10px;
        padding-top: 10px;
        padding-bottom: 20px;
        height: 100%;
    }

    a {
        text-decoration: none;
    }

    .detail-booking, .detail-review {
        height: auto;
        float: left;
        width: 100%;
    }

    .detail-review {
        background: #F7F7F7;
    }

    .detail-total {
        padding-top: 10px;
    }

    .detail-review-route {
        border: 1px solid #eee !important;
        padding: 10px;
        height: 100%;
    }

    .column-butom, .td-info-detail {
        height: 100%;
    }

    .column-butom {
        border: 1px solid #eee !important;
        padding-top: 10px;
    }

    .column-butom button {
        width: 90%;
    }

    .btn-vxr-lg {
        box-sizing: content-box;
        display: inline-block;
        padding: 10px 10px 10px 25px;
        color: #684d18;
        font-weight: 700;
        font-size: 14px;
        background-repeat: no-repeat;
        background-image: -webkit-radial-gradient(0 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em), -webkit-radial-gradient(100% 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em);
        background-image: radial-gradient(circle at 0 50%, rgba(255, 255, 224, 0) .4em, #f9af00 .5em), radial-gradient(circle at 100% 50%, rgba(255, 255, 224, 0) .4em, #f9af00 .5em);
        background-position: top left, top right;
        background-color: transparent !important;
        border: none;
        box-shadow: none;
        border-radius: 3px !important;
    }

    .btn-vxr-lg::before {
        background-image: url(../../../assets/images/bus-icon-6D4415.svg);
        background-repeat: no-repeat;
        float: left;
        left: 28px;
        top: 7px;
        position: absolute;
        border-right: 1.8px solid #e5a100;
        padding-right: 5px;
        height: 28px;
        padding-top: 5px;
        width: 22px;
        background-size: 15px 28px;
    }

    .btn-vxr-lg::before, .offer-tag::before {
        content: "";
    }

    .column-butom button {
        width: 90%;
    }

    .detail-review .btn-vxr-lg {
        height: 29px !important;
        font-size: 18px;
    }

    .detail-review .btn-vxr-lg:before {
        top: 12px;
    }

</style>
